export const CalculatorStyle = {
    wrapper: 'flex flex-col justify-between @4xl:flex-row gap-x-4xl gap-y-7 @xl:gap-y-4xl',
    input: 'flex flex-col lg:max-w-80 lg:w-1/2 gap-2xl',
    result: 'flex flex-col gap-y-xl min-w-52',
};
//# sourceMappingURL=CalculatorStyle.js.map